import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

const ViewSwitcher = ({ view, setView }) => {
  const handleChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  return (
    <Box>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleChange}
        aria-label="calendar view"
        size="small"
      >
        <ToggleButton value="day" aria-label="day view" sx={{ px: 2 }}>
          <CalendarViewDayIcon sx={{ mr: 1 }} />
          Day
        </ToggleButton>
        <ToggleButton value="week" aria-label="week view" sx={{ px: 2 }}>
          <CalendarViewWeekIcon sx={{ mr: 1 }} />
          Week
        </ToggleButton>
        <ToggleButton value="month" aria-label="month view" sx={{ px: 2 }}>
          <CalendarViewMonthIcon sx={{ mr: 1 }} />
          Month
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ViewSwitcher;
